export default __webpack_public_path__ + "static/brand_03-50a78e63fde6ed18af06801e3a570f4a.png";